// plugins/gtm.client.ts
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {

  const runTimeConfig = useRuntimeConfig();
  const route = useRoute();
  // Only run in production
  if (runTimeConfig.public.clientBaseUrl !== 'https://topauto.tn') 
    return;
  // Keep third-party analytics scripts away from credential-sensitive routes.
  if (
    route.path.startsWith('/authentication') ||
    route.path.includes('/dashboard/parameter/mot_de_pass')
  ) {
    return;
  }

  if (process.client) {
    // Appliquer les préférences de consentement par défaut
    const consentScript = document.createElement('script');
    consentScript.setAttribute('data-cookieconsent', 'ignore');
    consentScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'default_consent',
        'gtm.start': new Date().getTime()
      });
      window.gtag = function(){dataLayer.push(arguments);};
      gtag("consent", "default", {
        ad_personalization: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 500
      });
      gtag("set", "ads_data_redaction", true);
      gtag("set", "url_passthrough", false);
    `;
    document.head.appendChild(consentScript);

    // 2. Fonction pour injecter GTM une fois consentement donné
    const injectGTM = () => {
      if (!document.getElementById('gtm-script')) {
        const script = document.createElement('script');
        script.id = 'gtm-script';
        script.src = `https://www.googletagmanager.com/gtm.js?id=${runTimeConfig.public.gtm_id}`;
        script.async = true;
        document.head.appendChild(script);
      }
    };

    // 3. Vérifier si le consentement est déjà donné au chargement (ex: reload)
    const checkConsentAndInject = () => {
      if (window.CC) {
        const prefs = window.CC.getUserPreferences();
        if (prefs.acceptedCategories.includes('analytics')) {
          injectGTM();
        }
      }
    };

    // 4. Écouter l’événement vanilla-cookieconsent pour consentement
    window.addEventListener('cc:onConsent', () => {
      const prefs = window.CC?.getUserPreferences();
      if (prefs?.acceptedCategories.includes('analytics')) {
        injectGTM();
      }
    });

    // 5. Au démarrage, tenter d’injecter si consentement déjà donné
    checkConsentAndInject();
  }
});
